<template>
    <h1>logging out</h1>
</template>
<script>
export default {
    name: "logout",
    data(){
        return{

        }

    },
    mounted(){
        if(this.$USER_LOGIN.get().details.provider){
            this.$auth0.logout({
                logoutParams: {
                    returnTo: window.location.origin
                }
            });
        }
        localStorage.removeItem('user')
        localStorage.removeItem('access_token')
        localStorage.removeItem('created_by')
        localStorage.removeItem('wallet')
        localStorage.removeItem('wallet_metadata')
        localStorage.removeItem('shop_metadata')
        this.$router.push('/login')
    }
}
</script>